import center from "./center";
import { isEmbedded } from './embed-mode';

export const THEME_STORAGE_KEY = "app-theme";

export const THEMES = [
  {
    id: "ocean",
    name: "深空蓝",
    swatch: ["#06153c", "#1a7dff", "#3ef0ff"],
  },
  {
    id: "emerald",
    name: "碧海青",
    swatch: ["#07141c", "#2bb8c6", "#7ee8e2"],
  },
  {
    id: "amber",
    name: "暗金橙",
    swatch: ["#12141c", "#c9a45a", "#ead9b0"],
  },
];

export const PALETTES = {
  ocean: {
    primary: "#008AFF",
    primary2: "#41BAFF",
    accent: "#00FFF6",
    accent2: "#00C6FF",
    chartLine: "#2B8AFF",
    chartLineSoft: "rgba(43,138,255,.3)",
    chartOnline: "#00ADFF",
    chartOffline: "#0127C5",
    chartOfflineLabel: "#0078FF",
    chartGrid: "#0A2B6B",
    monitorMax: "#00C6FF",
    curveColors: [
      { color: "rgba(43,138,255, 1)", borderColor: "rgba(43,138,255, .3)" },
      { color: "rgba(28, 255, 199, 1)", borderColor: "rgba(28, 255, 199, .3)" },
      { color: "rgba(0, 229, 255, 1)", borderColor: "rgba(0, 229, 255, .3)" },
      { color: "rgba(243, 80, 7, 1)", borderColor: "rgba(243, 80, 7, .3)" },
      { color: "rgba(168, 47, 244, 1)", borderColor: "rgba(168, 47, 244, .3)" },
      { color: "rgba(243, 31, 191, 1)", borderColor: "rgba(243, 31, 191, .3)" },
    ],
  },
  emerald: {
    primary: "#2BB8C6",
    primary2: "#6ED4DC",
    accent: "#7EE8E2",
    accent2: "#3EC4D0",
    chartLine: "#2BB8C6",
    chartLineSoft: "rgba(43,184,198,.3)",
    chartOnline: "#3EC4D0",
    chartOffline: "#163844",
    chartOfflineLabel: "#2A6874",
    chartGrid: "#163844",
    monitorMax: "#3EC4D0",
    curveColors: [
      { color: "rgba(43,184,198, 1)", borderColor: "rgba(43,184,198, .3)" },
      { color: "rgba(28, 255, 199, 1)", borderColor: "rgba(28, 255, 199, .3)" },
      { color: "rgba(61, 204, 216, 1)", borderColor: "rgba(61, 204, 216, .3)" },
      { color: "rgba(243, 80, 7, 1)", borderColor: "rgba(243, 80, 7, .3)" },
      { color: "rgba(168, 47, 244, 1)", borderColor: "rgba(168, 47, 244, .3)" },
      { color: "rgba(243, 31, 191, 1)", borderColor: "rgba(243, 31, 191, .3)" },
    ],
  },
  amber: {
    primary: "#C9A45A",
    primary2: "#E0C888",
    accent: "#EAD9B0",
    accent2: "#D4B46A",
    chartLine: "#C9A45A",
    chartLineSoft: "rgba(201,164,90,.3)",
    chartOnline: "#D4B46A",
    chartOffline: "#3E3418",
    chartOfflineLabel: "#8A7038",
    chartGrid: "#3E3418",
    monitorMax: "#D4B46A",
    curveColors: [
      { color: "rgba(201,164,90, 1)", borderColor: "rgba(201,164,90, .3)" },
      { color: "rgba(28, 255, 199, 1)", borderColor: "rgba(28, 255, 199, .3)" },
      { color: "rgba(224, 192, 122, 1)", borderColor: "rgba(224, 192, 122, .3)" },
      { color: "rgba(243, 80, 7, 1)", borderColor: "rgba(243, 80, 7, .3)" },
      { color: "rgba(168, 47, 244, 1)", borderColor: "rgba(168, 47, 244, .3)" },
      { color: "rgba(243, 31, 191, 1)", borderColor: "rgba(243, 31, 191, .3)" },
    ],
  },
};

export function isThemeId(id) {
  return THEMES.some(function (item) {
    return item.id === id;
  });
}

export function getTheme() {
  // 看板嵌入态固定深空蓝，不读取或覆盖独立窗口的皮肤偏好。
  if (isEmbedded) return 'ocean';
  try {
    var id = window.localStorage.getItem(THEME_STORAGE_KEY) || "ocean";
    return isThemeId(id) ? id : "ocean";
  } catch (e) {
    return "ocean";
  }
}

export function getPalette(id) {
  return PALETTES[id || getTheme()] || PALETTES.ocean;
}

export function applyTheme(id, emit) {
  var theme = isEmbedded ? 'ocean' : (isThemeId(id) ? id : "ocean");
  document.documentElement.setAttribute("data-theme", theme);
  try {
    if (!isEmbedded) window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (e) {}
  if (emit !== false) {
    center.$emit("theme-change", theme);
  }
  return theme;
}



// WEBPACK FOOTER //
// ./src/service/theme-service.js